module.exports = __webpack_public_path__ + "assets/images/lesson-icon.9b28dbe9bc8fe9958b6f6192d329b947.svg";